import React, { useState, useEffect } from 'react';
import './FilterModal.css';

const FilterModal = ({ 
  isOpen, 
  onClose, 
  columns, 
  currentFilters = [], 
  onApplyFilters 
}) => {
  // Create a separate state object for each column
  const [filterStates, setFilterStates] = useState({});

  useEffect(() => {
    // Initialize filter states from currentFilters or empty
    const initialStates = {};
    columns.forEach(column => {
      const currentFilter = currentFilters.find(f => f.id === column.accessor);
      initialStates[column.accessor] = currentFilter?.value || '';
    });
    setFilterStates(initialStates);
  }, [columns, currentFilters]);

  const handleFilterChange = (columnAccessor, value) => {
    setFilterStates(prev => ({
      ...prev,
      [columnAccessor]: value
    }));
  };

  const handleApply = () => {
    const activeFilters = Object.entries(filterStates)
      .filter(([_, value]) => value)
      .map(([accessor, value]) => ({ id: accessor, value }));
    onApplyFilters(activeFilters);
    onClose();
  };

  const handleClear = () => {
    const clearedStates = {};
    columns.forEach(column => {
      clearedStates[column.accessor] = '';
    });
    setFilterStates(clearedStates);
    onApplyFilters([]);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="filter-modal-overlay">
      <div className="filter-modal">
        <div className="filter-modal-header">
          <h2>Filter Data</h2>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>

        <div className="filter-modal-content">
          <div className="filter-fields-grid">
            {columns.map(column => (
              <div key={column.accessor} className="filter-field">
                <label>{column.Header}</label>
                <input
                  type="text"
                  placeholder={column.filterType ?? 'Contains'}
                  style={{ width: "auto" }}
                  value={filterStates[column.accessor] || ''}
                  onChange={(e) => handleFilterChange(column.accessor, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="filter-modal-footer">
          <button className="clear-button" onClick={handleClear}>
            Clear All
          </button>
          <button className="apply-button" onClick={handleApply}>
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal; 